require('../app/ya_map.coffee')
window.pageInitFlag = false

pageInit = ->
  new window.YaMap("contacts-map");


$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/contacts.coffee